import { useEffect, useMemo, useRef } from 'react';

import { VIDEO_STATE } from 'Context/constant';
import { useMyCourseData } from 'Domain/MyCourseData';
import { useDisclosure } from 'Util/Hooks';
import useClassroomVideoPlayer from 'Util/Hooks/useClassroomVideoPlayer';

const useClassroomInterruption = () => {
  const [isInterrupting, activateInterruption, deactivateInterruption] = useDisclosure();

  const { play, pause, videoState, hasPlayer } = useClassroomVideoPlayer();
  const initialVideoStateRef = useRef(videoState);

  const { data: myCourseData } = useMyCourseData();

  useEffect(() => {
    if (!hasPlayer) return;

    if (isInterrupting) {
      initialVideoStateRef.current = videoState;
      if (videoState === VIDEO_STATE.ENDED) {
        window.postMessage('MODAL_INTERRUPT');
      }
      if (videoState !== VIDEO_STATE.PAUSED) {
        pause();
      }
    } else {
      if (initialVideoStateRef.current === VIDEO_STATE.PLAY) {
        play();
      }
    }
  }, [isInterrupting, videoState, hasPlayer]);

  const { courseCode, courseTitle, progressPercent } = useMemo(() => {
    const courseInfo = myCourseData?.courseInfo ?? {};
    const { courseCode, title } = courseInfo ?? {};
    const progressPercent = courseInfo?.classroomProgress?.progressPercent ?? {};

    return { courseCode, courseTitle: title, progressPercent };
  }, [myCourseData]);

  return {
    isInterrupting,
    activateInterruption,
    deactivateInterruption,
    courseData: { courseCode, courseTitle, progressPercent },
  };
};

export default useClassroomInterruption;
